// istanbul ignore file
import store from '../store/index'
import { SaveDefaultViewObjectUpdateAction } from '../features/device-dashboard/redux/saveDefaultViewObjectSlice'

interface Device {
  deviceId: string
  cimCodeIds: string[]
  kpidefinitionIds?: string[]
}
export interface Widget {
  widgetId: string
  displayname: string
  devices: Device[]
  assets?: Device[] | undefined | null
}

interface ISaveDefaultView {
  assetDashBoardDefaultView: Widget[]
}

export const updateSaveDefaultObject = (
  prevSavedObject: ISaveDefaultView | null,
  newData: Widget,
  currentWigetId: string
): void => {
  let updateSaveDefault: ISaveDefaultView

  if (prevSavedObject === null || prevSavedObject === undefined) {
    updateSaveDefault = {
      assetDashBoardDefaultView: [newData]
    }
  } else {
    updateSaveDefault = {
      assetDashBoardDefaultView: prevSavedObject.assetDashBoardDefaultView.map(
        (widget) => ({ ...widget })
      )
    }
    const index = updateSaveDefault.assetDashBoardDefaultView.findIndex(
      (widget) => widget.widgetId === currentWigetId
    )

    if (index !== -1) {
      updateSaveDefault.assetDashBoardDefaultView[index] = newData
    } else {
      updateSaveDefault.assetDashBoardDefaultView.push(newData)
    }
  }
  store.dispatch(SaveDefaultViewObjectUpdateAction(updateSaveDefault))
}
